import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_ADMIN_TAXONOMIES_VERSIONS_QUERY_KEY } from './useGetAdminTaxonomyVersions';

import TaxonomiesService, {
  CloneTaxonomyDto,
} from '@/services/TaxonomiesService';

export function useCloneTaxonomy() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (cloneTaxonomyDto: CloneTaxonomyDto) =>
      TaxonomiesService.cloneTaxonomy(cloneTaxonomyDto),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: GET_ADMIN_TAXONOMIES_VERSIONS_QUERY_KEY(
          variables.targetCustomerId,
        ),
      });
    },
  });

  return {
    cloneTaxonomy: mutateAsync,
    isLoading: isPending,
  };
}
